<section class="aux-page aux-testimonials">
    <div class="aux-head">
        <p class="aux-eyebrow">Testimonials</p>
        <h1>What Customers Say</h1>
        <p>
            Real feedback from clients who worked with us on financing and
            vehicle sourcing.
        </p>
    </div>

    <div class="aux-grid three">
        <article class="aux-quote">
            <p>
                “When you go in and meet these guys, they make you feel like
                part of their family. You’re not just a number, you really
                matter.”
            </p>
            <cite>Laura Smyth</cite>
        </article>

        <article class="aux-quote">
            <p>
                “Top prices and true to their word. I had bad credit and boom,
                they got me approved.”
            </p>
            <cite>Marco Brayley</cite>
        </article>

        <article class="aux-quote">
            <p>
                “We are really enjoying our new / used vehicle. It rides really
                smooth.”
            </p>
            <cite>Caroline Herda</cite>
        </article>
    </div>
</section>
